"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleIcon = void 0;
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const shared_1 = require("../../shared");
const Styled = styled_components_1.default.a `
	&& {
		padding: 16px 12px;
	}
	&:focus {
		outline-offset: -4px;
	}
`;
const LocaleIcon = ({ currentLocale }) => {
    const { messages } = (0, shared_1.useMessages)();
    return (react_1.default.createElement(Styled, { onMouseDown: epic_games_nav_shared_1.stopFocusOnClick, "data-locale": currentLocale, title: currentLocale || messages.locale, role: "menuitem" },
        react_1.default.createElement("i", { className: "eg-header-icon-locale" })));
};
exports.LocaleIcon = LocaleIcon;
//# sourceMappingURL=LocaleIcon.js.map